import StyleOverrider from "mrf/utils/StyleOverrider";
import tw, { styled } from "twin.macro";

const DefaultScrollBar = styled.div`
    & {
        scrollbar-width: thin;
        scrollbar-color: transparent transparent;
    }
    &::-webkit-scrollbar {
        width: 10px;
    }
    &::-webkit-scrollbar-track {
        ${tw`m-2 bg-transparent`}
    }
    &::-webkit-scrollbar-thumb {
        ${tw`bg-white bg-opacity-50 rounded-lg hover:bg-opacity-75`}
    }
    ${tw`overflow-y-scroll`}
`;

const [ScrollBar, setScrollBarStyle] = StyleOverrider(DefaultScrollBar);
export { ScrollBar as default, DefaultScrollBar, setScrollBarStyle };
